module.exports = __webpack_public_path__ + "img/olympic-background-desktop.87a0f4ee.png";